import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../../components/Auth/AuthLayout';
import FormField from '../../../components/Auth/FormField';
import LoadingButton from '../../../components/Auth/LoadingButton';

const AirlinerConfirmPasswordPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Simulate success
      alert('Password confirmed successfully!');
      navigate('/airliner');
    } catch (error) {
      setErrors({ submit: 'Invalid password. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const confirmIcon = (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
  );

  return (
    <AuthLayout
      title="Confirm Password"
      subtitle="Please confirm your password to continue"
      icon={confirmIcon}
      iconBgColor="bg-jet-yellow-100"
      iconColor="text-jet-yellow-600"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-jet-yellow-50 border border-jet-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <svg className="w-5 h-5 text-jet-yellow-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <div>
              <h4 className="text-sm font-medium text-jet-yellow-900 mb-1">Security Verification</h4>
              <p className="text-sm text-jet-yellow-800">
                For your security, please confirm your current password before proceeding with this action.
              </p>
            </div>
          </div>
        </div>

        <FormField
          label="Current Password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Enter your current password"
          required
          error={errors.password}
          showPasswordToggle
          showPassword={showPassword}
          onTogglePassword={() => setShowPassword(!showPassword)}
        />

        {/* Submit Error */}
        {errors.submit && (
          <div className="bg-jet-red-50 border border-jet-red-200 rounded-md p-3">
            <p className="text-sm text-jet-red-600">{errors.submit}</p>
          </div>
        )}

        {/* Submit Button */}
        <LoadingButton
          type="submit"
          loading={loading}
          loadingText="Confirming..."
          className="bg-jet-yellow hover:bg-jet-yellow-hover text-jet-gray-900"
        >
          Confirm Password
        </LoadingButton>

        {/* Additional Links */}
        <div className="text-center space-y-3">
          <button
            type="button"
            onClick={() => navigate('/airliner/auth/forgot-password')}
            className="text-jet-yellow-600 hover:text-jet-yellow-700 text-sm transition-colors"
          >
            Forgot your password?
          </button>
        </div>

        {/* Back to Dashboard */}
        <div className="text-center pt-4 border-t border-jet-gray-200">
          <button
            type="button"
            onClick={() => navigate('/airliner')}
            className="text-jet-gray-600 hover:text-jet-gray-900 text-sm transition-colors"
          >
            ← Back to Dashboard
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default AirlinerConfirmPasswordPage;